import { type ReactNode, type Ref } from 'react';
import { cn } from '@/utils/tailwind.util';
import { DetailHeroBanner } from './DetailHeroBanner';
export interface DetailPageLayoutProps {
  /** 상단 전체 너비 배너 이미지. 없으면 `DetailHeroBanner` 가 기본 그라데이션 배경을 그린다. */
  bannerUrl?: string;
  /** 배너 alt. 장식용이면 빈 문자열 */
  bannerAlt?: string;
  /** 배너 이미지가 없을 때의 배경. `DetailHeroBanner.background` 로 넘어간다. */
  bannerBackground?: string;
  /** 배너에 60px 겹쳐 올라오는 히어로 카드 */
  hero: ReactNode;
  /** 우측 250px 사이드. 모바일에서는 숨고 하단 고정 CTA 가 대신한다. 없으면 본문이 전폭을 쓴다 */
  aside?: ReactNode;
  /** 바깥 컨테이너에 덧붙일 클래스 (예: 로그인 가드가 하단 여백을 줄이는 경우) */
  containerClassName?: string;
  /** 본문 영역 전체를 관찰해야 할 때 (스크롤 기반 서브헤더 등) */
  mainRef?: Ref<HTMLDivElement>;
  /** 좌측 732px 본문 */
  children: ReactNode;
}

/**
 * 상세 화면 셸 — 배너 · 1024 컨테이너 · 히어로 겹침 · 732+250 2단.
 * 퀴즈 상세와 폴더 상세가 함께 쓴다.
 *
 * 페이지가 채우는 건 슬롯 3개(`hero` · `children` · `aside`)뿐이다.
 * `aside` 안쪽 구조(sticky 위치, 여러 블록, ref)는 화면마다 달라 슬롯째로 받는다.
 */
export const DetailPageLayout = ({
  bannerUrl,
  bannerAlt = '',
  bannerBackground,
  hero,
  aside,
  containerClassName,
  mainRef,
  children
}: DetailPageLayoutProps) => {
  return <>
      <DetailHeroBanner bannerUrl={bannerUrl} alt={bannerAlt} background={bannerBackground} data-sentry-element="DetailHeroBanner" data-sentry-source-file="DetailPageLayout.tsx" />

      <div className={cn('mx-auto mb-[150px] w-full max-w-[1024px] px-md', 'mobile-lg:px-lg', 'tablet-lg:mb-[100px] tablet-lg:px-0', containerClassName)}>
        {/* 배너 위로 끌어올려 히어로 카드가 겹치게 한다. */}
        <div className={'-mt-[42px] tablet-sm:-mt-[60px]'}>
          <div ref={mainRef} className={'flex flex-col gap-lg'}>
            <div className={'relative'}>{hero}</div>

            <div className={'flex flex-col gap-lg tablet-sm:flex-row tablet-sm:gap-[42px]'}>
              <div className={'flex-1 tablet-sm:w-[732px]'}>{children}</div>

              {aside != null && <aside className={'hidden shrink-0 tablet-sm:flex tablet-sm:w-[250px] tablet-sm:flex-col'}>
                  {aside}
                </aside>}
            </div>
          </div>
        </div>
      </div>
    </>;
};